module.exports = __webpack_public_path__ + "img/clim_pack.9d7f8cdb.png";